module.exports = __webpack_public_path__ + "img/release-discussion.15b4647.png";